import { StateCreator, StoreApi } from 'zustand';
import { LoadingStore, LoadingActions, LoadingState } from './types';
import { ResourceMapperStore } from '../../ResourceMapperStoreTypes';
import { APIState } from '../../../../../models/APIState';

const initialState: LoadingState = {
  unmappedResourcesStatus: APIState.LOADING,
  loadInstancesStatus: APIState.LOADING,
  resourceSelectStatus: APIState.EMPTY,
  isUpdatingResources: false,
  gettingUnmappedResources: false,
  isLoadingProductsMasterList: false,
  isLoadingIgnoreProduct: false,
};

const actions = (set: StoreApi<ResourceMapperStore>['setState']): LoadingActions => ({});

export const createLoadingSlice: StateCreator<LoadingStore> = (set) => ({
  ...initialState,
  ...actions(set),
});

export type LoadingSlice = ReturnType<typeof createLoadingSlice>;
